import Administrative from "./Administrative";

export default Administrative;
